import { IStyle, makeStyles } from '@fluentui/react-theme-provider';
import { tokens } from '@fluentui/react-components';
import { BreakPoints, BreakPointsMin } from '../../Constant';
import { shorthands, makeStyles as makeStylesComponent } from '@fluentui/react-components';
import { linkGreen } from '../Shared/Shared';

export const useLevelOneStyles = () => {
  const container: IStyle = {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    columnGap: '12px',
  };
  const error: IStyle = {
    rowGap: '16px !important',
  };
  const headerContainer: IStyle = {
    display: 'flex',
    flexDirection: 'row',
    gap: '20px 48px',
    alignItems: 'center',
    [BreakPoints.l]: {
      flexDirection: 'column',
      alignItems: 'start',
    },
  };
  const sectionContainer: IStyle = {
    marginTop: '-12px',
  };
  const levelOneContainer: IStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridAutoRows: '',
    width: '100%',
    [BreakPoints.s]: {
      display: 'block',
      columnCount: 1,
    },
    [BreakPointsMin.s]: {
      columnGap: '16px',
    },
    marginTop: '16px',
  };

  const levelOneContainerOnAssistExpand: IStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridAutoRows: '',
    width: '100%',
    '@media (max-width:805px)': {
      display: 'block',
      columnCount: 1,
    },
    '@media (min-width:805px)': {
      columnGap: '16px',
    },
    marginTop: '16px',
  };

  const accordionItem: IStyle = {
    border: `0px solid ${tokens.colorNeutralBackground1Pressed}`,
    backgroundColor: tokens.colorNeutralBackground1,
    boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.14)',
    borderRadius: '4px',
    marginBottom: '16px',
    breakInside: 'avoid',
  };

  const professionColumn: IStyle = {
    flex: 1,
    minWidth: '200px',
    '@media (max-width: 1120px)': {
      flex: '0 0 100%',
      maxWidth: '400px',
    },
  };
  const searchInput: IStyle = {
    width: '300px',
    height: '32px',
    '@media (max-width: 320px)': {
      width: '130px',
    },
  };

  const srOnly: IStyle = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: 0,
  };

  const popoverContainer: IStyle = {
    width: '250px',
  };

  const quickSearchPopover: IStyle = {
    ':hover': { backgroundColor: tokens.colorNeutralBackground1Hover, cursor: 'pointer' },
  };

  const quickSearchPopoverSpacing: IStyle = {
    marginTop: '8px',
  };

  const quickSearchLink: IStyle = {
    textDecoration: 'none',
    color: tokens.colorNeutralForeground1,
    ':focus': { backgroundColor: tokens.colorNeutralBackground1Hover, cursor: 'pointer' },
  };

  return makeStyles({
    container,
    headerContainer,
    levelOneContainer,
    levelOneContainerOnAssistExpand,
    sectionContainer,
    accordionItem,
    professionColumn,
    searchInput,
    srOnly,
    popoverContainer,
    quickSearchPopover,
    quickSearchPopoverSpacing,
    quickSearchLink,
    error,
  })();
};

export const useTabStyles = makeStylesComponent({
  root: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  panels: {
    ...shorthands.padding(0, '10px'),
  },
  tabName: {
    fontSize: '14px',
    ':hover::after': { backgroundColor: linkGreen },
    '::after': { backgroundColor: linkGreen },
  },
  selectedTabName: {
    color: linkGreen,
    fontSize: '14px',
  },
  unSelectedTabName: {
    color: '#605e5c',
    fontSize: '14px',
  },
});
